import * as React from "react";
import type { IMegaMenuContext, IMegaMenuEntry, IMegaMenuItem } from "./definitions";
import { DynLabel, AppLabel } from "@@services/i18nservice";
import { NavLink } from "react-router-dom";
import type { States } from '@@services/services';
import { ILocationMatchProp, ILocationProp } from "@@data/entities";
import { Entities } from "@inwink/entities/entities";

export interface IMegaMenuPanelItemPropsBase extends IMegaMenuContext {
    event?: States.IEventState;
    community?: States.ICommunityState;
    onHide?: () => void;
    location?: ILocationProp;
    match?: ILocationMatchProp;
    onMenuItemClicked?: () => void;
    i18nHelper?: Entities.i18nHelper;
}

export interface IMegaMenuPanelItemProps extends IMegaMenuPanelItemPropsBase {
    item: IMegaMenuItem;
    entry: IMegaMenuEntry;
    onToggleFavorites: (items) => void;
}

export interface IMegaMenuPanelItemState {

}

export class MegaMenuPanelItem extends React.Component<IMegaMenuPanelItemProps, IMegaMenuPanelItemState> {
    render() {
        const classes = ["megamenu-panel-item",
            this.props.item.favorite ? MegaMenuFavoriteButtonIsFavClassName : MegaMenuFavoriteButtonIsNotFavClassName];
        return <div className={classes.join(' ')}>
            <MegaMenuPanelLink {...this.props} className="megamenu-panel-item-link" />
            <MegaMenuFavoriteButton isFav={this.props.item.favorite} i18nHelper={this.props.i18nHelper} toggleFavorite={() => {
                this.props.onToggleFavorites([{...this.props.item, menuKey: this.props.entry.key}]);
            }} />
        </div>;
    }
}

export const MegaMenuFavoriteButtonIsFavClassName = 'megamenu-favorite-wrapper favorite';
export const MegaMenuFavoriteButtonIsNotFavClassName = 'megamenu-favorite-wrapper';

export interface IMegaMenuFavoriteButtonProps {
    toggleFavorite: () => void;
    isFav: boolean;
    i18nHelper?: Entities.i18nHelper;
}

export class MegaMenuFavoriteButton extends React.Component<IMegaMenuFavoriteButtonProps, any> {
    render() {
        return <div
            className="megamenu-favorite-button clickable"
            title={this.props.i18nHelper?.translate('megamenu.favorite.button.title')}
            onClick={(arg) => {
                arg.preventDefault();
                this.props.toggleFavorite();
            }}
        >
            {this.props.isFav ? <i className="inwink-star" /> : <i className="inwink-star-outline" />}
        </div>;
    }
}

export interface IMegaMenuPanelLinkProps extends IMegaMenuPanelItemPropsBase {
    item: IMegaMenuItem | IMegaMenuEntry;
    className: string;
    showIcon?: boolean;
    useFavTitle?: boolean;
}
export class MegaMenuPanelLink extends React.Component<IMegaMenuPanelLinkProps, IMegaMenuPanelItemState> {
    menuItemClicked = (arg) => {
        // arg?.preventDefault();
        arg?.stopPropagation();

        if (this.props.onHide) {
            this.props.onHide();
        }
        if (this.props.item.onClick) {
            this.props.item.onClick(this.props);
        }
        if (this.props.onMenuItemClicked) {
            this.props.onMenuItemClicked();
        }

    };

    render() {
        const it = this.props.item;
        const title = this.props.useFavTitle && it.titleFav ? it.titleFav : it.title;

        const classNames: string[] = ["megamenupanelitem", this.props.className];
        const content = <>
            {this.props.showIcon && it.icon ? <div className="icon"><i className={"item-icon " + it.icon} /></div> : null}
            {it.label ? <DynLabel className="item-title" i18n={it.label} /> : null}
            {title ? <AppLabel className="item-title" i18n={title} /> : null}
            {(!this.props.useFavTitle && it.badgeText) ? (
                <span className="item-badge">
                    <AppLabel i18n={it.badgeText} />
                </span>
            ) : null}
        </>;

        if (this.props.item.link) {
            const eventUrl = this.props.event
                && this.props.event.eventdetail
                && ((this.props.event.eventdetail as any).eventKey || this.props.event.eventdetail.tinyUrl);
            const communityUrl = this.props.community?.detail?.communityKey;

            const linkTarget = this.props.item.link
                .replace('{customerid}', this.props.match.params.customerid)
                .replace('{tenantid}', this.props.match.params.tenantid)
                .replace('{eventid}', this.props.match.params.eventid)
                .replace('{communityid}', this.props.match.params.communityid)
                .replace('{eventtinyurl}', eventUrl)
                .replace('{communityurl}', communityUrl);
            return <NavLink
                className={classNames.join(" ")}
                target={this.props.item.target}
                activeClassName="accent active"
                exact={!this.props.item.nonExact}
                to={linkTarget}
                onClick={this.menuItemClicked}
            >
                {content}
            </NavLink>;
        }

        return <a
            className={classNames.join(" ")}
            onClick={this.menuItemClicked}
        >
            {content}
        </a>;
    }
}